import { render, staticRenderFns } from "./PlayerSelectModalSection.vue?vue&type=template&id=4508327e&scoped=true"
import script from "./PlayerSelectModalSection.vue?vue&type=script&lang=ts"
export * from "./PlayerSelectModalSection.vue?vue&type=script&lang=ts"
import style0 from "./PlayerSelectModalSection.vue?vue&type=style&index=0&id=4508327e&prod&lang=scss&scoped=true"
import style1 from "./PlayerSelectModalSection.vue?vue&type=style&index=1&id=4508327e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508327e",
  null
  
)

export default component.exports